
@if (control) {
  <div class="relative">
    @if (label) {
      <label class="input-label" [for]="id+'_sub'">{{fullLabel}}
        <ng-content select="label"></ng-content>
      </label>
    }
    <div class="relative shadow-sm">
      <input class="input disabled:bg-extend-grey" [id]="id+'_sub'" [formControl]="control" [type]="inputType" [readonly]="readonly ? 'readonly' : null" [autocomplete]="'new-'+id" [class.input-invalid]="!control.valid &amp;&amp; control.enabled &amp;&amp; control.touched" [placeholder]="label" [attr.aria-invalid]="!control.valid &amp;&amp; control.enabled &amp;&amp; control.touched" [attr.aria-describedby]="id+'_sub_error'">
    </div>@if (!control.valid && control.enabled && control.touched) {
    <span class="input-invalid-hint" [id]="id+'_sub_error'">{{ control.value | inputErrorMessage:control }}</span>
  }
</div>
}